import assetIcBurgerMenu from './ic-burger-menu.svg';
import assetIcNavWishlist from './ic-nav-wishlist.svg';
import assetIcSearch from './ic-search.svg';
export enum HeaderIconName {
  Menu = 'Menu',
  NavWishlist = 'NavWishlist',
  NavSearch = 'NavSearch',
}

export const headerIconAssets: {
  [key in HeaderIconName]: string;
} = {
  [HeaderIconName.Menu]: assetIcBurgerMenu,
  [HeaderIconName.NavWishlist]: assetIcNavWishlist,
  [HeaderIconName.NavSearch]: assetIcSearch,
};
